export interface NprogressState {
  active?: boolean;
  value?: number;
}
